(function(window, playRewindControlsViewFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.PlayRewindControlsView = playRewindControlsViewFactory(window.document, namespace.localizationStrings, namespace.viewHelper, namespace.templates, namespace.highlightDisabler, namespace.playerConfiguration, namespace.cssClasses, namespace.events, namespace.tabIndex);
})(this, function(document, localizationStrings, viewHelper, templates, highlightDisabler, playerConfiguration, cssClasses, events, tabIndex) {
   'use strict';

   var PlayRewindControlsView = function($container, mediaElement) {
      var _markup = templates.play_rewind_controls_template({
         accessBtnRewind: localizationStrings.strings.accessBtnRewind,
         accessBtnPlay: localizationStrings.strings.accessBtnPlay,
         rewindIndex: tabIndex.Rewind,
         playIndex: tabIndex.Play
      });
      $container.find('.play-rewind-controls').html(_markup);

      var _disabled = false;
      var _$playControl = $container.find('.play-control');
      var _$rewindControl = $container.find('.rewind-control');
      var _$playButtonGlyph = _$playControl.find('.play-button-glyph');
      var _$pauseButtonGlyph = _$playControl.find('.pause-button-glyph');

      var disableKeyListeners = function() {
         _$playControl.attr('tabindex', tabIndex.Disabled);
         _$rewindControl.attr('tabindex', tabIndex.Disabled);
         _disabled = true;
      };

      var enableKeyListeners = function() {
         _$playControl.attr('tabindex', tabIndex.Play);
         _$rewindControl.attr('tabindex', tabIndex.Rewind);
         _disabled = false;
      };

      $container.on(events.Controls.Disable, disableKeyListeners);
      $container.on(events.Controls.Enable, enableKeyListeners);

      mediaElement.addEventListener(events.Media.Play, function() {
         _$playButtonGlyph.hide();
         _$pauseButtonGlyph.show();
         _$playControl.attr('aria-pressed', true);
      });

      mediaElement.addEventListener(events.Media.Pause, function() {
         _$pauseButtonGlyph.hide();
         _$playButtonGlyph.show();
         _$playControl.attr('aria-pressed', false);
      });

      _$playControl.click(function(e) {
         e.preventDefault();
         togglePlay();
      });

      var togglePlay = function() {
         if (_disabled) {
            return;
         }

         if (mediaElement.paused) {
            mediaElement.play();
         } else {
            mediaElement.pause();
         }
      };

      var setInitialFocus = function() {
         if (viewHelper.elementOrChildHasFocus($container)) {
            _$playControl.focus();
            highlightDisabler.disableHighlights(_$playControl);
         }
      };

      if (playerConfiguration.getAllowRewind() !== -1) {
         _$rewindControl.click(function() {
            mediaElement.play(Number(mediaElement.currentTime) - playerConfiguration.getAllowRewind());
         });
      } else {
         _$rewindControl.addClass(cssClasses.hide);
      }

      _$pauseButtonGlyph.hide();

      return {
         togglePlay: togglePlay,
         setInitialFocus: setInitialFocus
      };
   };

   return {
      create: PlayRewindControlsView
   };
});
